import {useAuthenticatedSessionSnapshot, useUser} from "UserProvider";
import {useHistory} from "utils/HistoryUtils";
import SessionStorage from "data/SessionStorage";
import {forgetKeptUploadsOf} from "home/resume/forgetKeptUploads";

/**
 * Shared logout action for the logged-in chrome: clears the persisted session, resets the
 * in-memory user and returns to the public home route.
 *
 * Consumed by the ProfileMenu's Logout entry (ticket #28; the top-bar avatar menu since ui#96),
 * kept as a single seam so logout can never drift — previously the retired rail hand-rolled a broken
 * `window.location.href = window.location.host` redirect next to the popover's SPA navigation.
 *
 * It also forgets the unfinished uploads the account kept in this browser (kitecorp/transferify-ui#3204),
 * never waited for: signing out does not hang on storage.
 */
export function useLogout(): () => void {
	const [, , logout] = useUser();
	const [session] = useAuthenticatedSessionSnapshot();
	const history = useHistory();
	return () => {
		void forgetKeptUploadsOf(session);
		SessionStorage.logout();
		logout();
		history.replace("/");
	};
}
